module.exports = {
  'f10': 'Telecommunications companies only',
  'f11': 'Internet companies only',
  'p8': 'Internet companies only',
  'p13': 'Internet companies only'
};
